const CloseIcon = (
  props: React.SVGProps<SVGSVGElement> & { 'data-testid'?: string }
) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.3431 10.3434L16 16.0002M16 16.0002L21.6569 21.6571M16 16.0002L10.3431 21.6571M16 16.0002L21.6569 10.3434"
      stroke="#26262B"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CloseIcon;
